<template>
  <div class="user">
    <div class="photo">
      <img :src="photoSrc" alt="avatar" @error="avatarFailed = true" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="isDemo(false)">
          DEMO
          <b class="caret"></b>
        </span>
        <span v-else>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li class="w-100">
                <router-link class="md-primary" :to="{ path: '/myprofile' }">
                  <span class="sidebar-mini"
                    ><i class="material-icons">person</i></span
                  >
                  <span class="sidebar-normal">{{ $t("myProfile") }}</span>
                </router-link>
              </li>

              <li class="w-100">
                <router-link class="md-primary" :to="{ path: '/billing' }">
                  <span class="sidebar-mini"
                    ><i class="material-icons">payment</i></span
                  >
                  <span class="sidebar-normal">{{ $t("billing") }}</span>
                </router-link>
              </li>

              <li class="w-100">
                <router-link class="md-primary" :to="{ path: '/systemfeatures' }">
                  <span class="sidebar-mini"
                    ><i class="material-icons">tune</i></span
                  >
                  <span class="sidebar-normal">{{ $t("System Features") }}</span>
                </router-link>
              </li>

              <li class="w-100">
                <router-link
                  class="md-primary"
                  :to="{ path: '/gotrading/user-menu' }"
                >
                  <span class="sidebar-mini"
                    ><i class="material-icons">view_list</i></span
                  >
                  <span class="sidebar-normal">{{ $t("userMenu.title") }}</span>
                </router-link>
              </li>

              <li class="w-100">
                <router-link class="md-primary" :to="{ path: '/ia' }">
                  <span class="sidebar-mini"
                    ><i class="material-icons">auto_awesome</i></span
                  >
                  <span class="sidebar-normal">{{ $t("aiHub.title") }}</span>
                </router-link>
              </li>

              <!-- Teléfono: notificaciones de emails y del Agente IA. -->
              <MobilePushMenuItem v-if="isMobileLayout" />

              <li class="w-100">
                <a @click="logout">
                  <span class="sidebar-mini"
                    ><i class="material-icons">logout</i></span
                  >
                  <span class="sidebar-normal">{{ $t("logout") }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { logoutAction } from "@/pages/Auth/actions";
import permissionsMixin from "@/mixins/permissionsMixin";
import mobileLayoutMixin from "@/mixins/mobileLayoutMixin";
import MobilePushMenuItem from "@/components/mobile/MobilePushMenuItem.vue";

import { getMyProfileAction } from "@/pages/Users/actions";

export default {
  mixins: [permissionsMixin, mobileLayoutMixin],
  props: {
    /** Logo del sitio: se muestra si el usuario no tiene imagen o no carga. */
    logo: { type: String, default: "" },
  },
  components: {
    CollapseTransition,
    MobilePushMenuItem,
  },
  data() {
    return {
      role: false,
      credits: "none",
      isClosed: true,
      title: "",
      avatar: "",
      avatarFailed: false,
    };
  },
  computed: {
    photoSrc() {
      if (this.avatar && !this.avatarFailed) return this.avatar;
      return this.logo || process.env.BASE_URL + "img/default-avatar.png";
    },
  },

  created() {
    this.role = localStorage.getItem("role");
    if (this.role == "client") {
      // this.logout()
    }

    // Cargar el perfil del usuario
    this.getMyProfile();
  },
  methods: {
    async getMyProfile() {
      try {
        const data = await getMyProfileAction();
        this.title = data.data.name || data.data.email || "Usuario";
        if (data.data.avatar) {
          this.avatar = data.data.avatar;
          this.avatarFailed = false;
        }
      } catch (error) {
        console.error("Error al cargar el perfil:", error);
        this.title = "Usuario";
      }
    },

    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
    async logout() {
      let urllogin = "/login";

      if (this.role == "client") {
        urllogin = "/loginclient";
      }

      await logoutAction();
      if (this.$route.path !== urllogin && this.isDemo(false)) {
        window.location.href = "https://gotake.it";
        return;
      }
      if (this.$route.path !== urllogin) {
        this.$router.push(urllogin);
      }
    },
  },
};
</script>
<style>
.iconlanguage {
  margin-right: 17px !important;
  margin-left: 12px !important;
  color: white !important;
  margin-top: 6px !important;
}

.collapsed {
  transition: opacity 1s;
}
.md-field.md-theme-default > .md-icon:after {
  background-color: inherit !important;
}

.sidebar .credits .md-icon.md-theme-default.md-icon-font,
.credits i {
  font-size: 10px !important;
  color: var(--bs-primary) !important;
}

.credits {
  float: left;
  margin-left: 18px;
  color: white;
  font-size: 11px;
  margin-top: -5px;
  color: var(--bs-primary) !important;
  overflow: hidden;
  height: 19px;
}
</style>
